import React, { Component } from 'react';
import LeftBar from '../Site/LeftBar';
import ProductBinDetail from './ProductBinDetail';

import './style.css';

class Products extends Component {

  render() {
    return (
      <div>
        <LeftBar />
        <ProductBinDetail />
      </div>    


    );
  }
}

export default Products;